import { __ } from '@wordpress/i18n';
import { createInterpolateElement } from '@wordpress/element';

const MultiCurrencyUpsell = () => {
	return (
		<span className="cmgf-multi-currency-upsell">
			{
				createInterpolateElement(
					__(
						'Want to add multi-currency switcher to your Gravity Forms? Check out our other plugin <a>Multi-currency for Gravity Forms</a>',
						'currency-manager-for-gravity-forms'
					),
					{
						// eslint-disable-next-line jsx-a11y/anchor-has-content
						a: <a href="https://ideawp.com/plugin/multi-currency-for-gravityforms/?utm_source=cmfgf&utm_medium=plugin&utm_campaign=wporg" target="_blank" rel="noopener noreferrer" />
					}
				)
			}
		</span>
	);
};

export default MultiCurrencyUpsell;